import React from 'react';
import { Alert } from 'reactstrap';
import { PermissionField } from '../Common/permissions';
import { usePermission } from './usePermission';

type Props = {
  permission: PermissionField;
  children: React.ReactNode;
}

const RequiresPermissionTemplate: React.FC<Props> = ({ permission, children }) => {
  const allowed = usePermission(permission);

  if (allowed) return <>{children}</>;

  return <Alert color='warning'>You do not have access to this resource.</Alert>;
}

export default RequiresPermissionTemplate;
